export enum InternalServerErrorCode {
  NotAuthenticated = 1001,
}
